"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSupportSourceFilterI18nKey = exports.getDataSyncFilterI18nKey = exports.getPlanTypeFilterI18nKey = exports.getCollectionI18nKey = void 0;

var _memoize = _interopRequireDefault(require("hs-lodash/memoize"));

var Sync = _interopRequireWildcard(require("ecosystem-marketplace-core/constants/dataSyncs/Sync"));

var PlanType = _interopRequireWildcard(require("ecosystem-marketplace-core/constants/pricings/PlanType"));

var StorefrontCollection = _interopRequireWildcard(require("../constants/StorefrontCollection"));

var SupportSource = _interopRequireWildcard(require("../constants/search/SupportSource"));

var getCollectionI18nKey = (0, _memoize.default)(function (collection) {
  var textKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'titleText';

  var key = function () {
    switch (collection) {
      case StorefrontCollection.POPULAR:
        return 'popular';

      case StorefrontCollection.NEW:
        return 'new';

      case StorefrontCollection.FREE:
        return 'free';

      case StorefrontCollection.FOR_MARKETING_TEAMS:
        return 'forMarketing';

      case StorefrontCollection.FOR_SALES_TEAMS:
        return 'forSales';

      case StorefrontCollection.FOR_CUSTOMER_SUCCESS_TEAMS:
        return 'forCustomerSuccess';

      case StorefrontCollection.FOR_STARTUPS:
        return 'forStartups';

      case StorefrontCollection.FOR_AGENCIES:
        return 'forAgencies';

      case StorefrontCollection.HOMEMADE:
        return 'hubspot';

      case StorefrontCollection.PIESYNC:
        return 'piesync';

      case StorefrontCollection.CMS:
        return 'cms';

      case StorefrontCollection.ABM:
        return 'abm';

      default:
        {
          return collection;
        }
    }
  }();

  return "appMarketplace.storefront.filters.collection.items." + key + "." + textKey;
}, function (filter, textKey) {
  return filter + ":" + textKey;
});
exports.getCollectionI18nKey = getCollectionI18nKey;
var getPlanTypeFilterI18nKey = (0, _memoize.default)(function (planType) {
  var key = function () {
    switch (planType) {
      case PlanType.FREE:
        return 'free';

      case PlanType.MONTHLY:
        return 'monthly';

      case PlanType.YEARLY:
        return 'yearly';

      case PlanType.ONE_TIME:
        return 'oneTime';

      default:
        return null;
    }
  }();

  return "appMarketplace.storefront.filters.planType.items." + key;
});
exports.getPlanTypeFilterI18nKey = getPlanTypeFilterI18nKey;
var getDataSyncFilterI18nKey = (0, _memoize.default)(function (sync) {
  var key = function () {
    switch (sync) {
      case Sync.INBOUND:
        return 'inbound';

      case Sync.OUTBOUND:
        return 'outbound';

      case Sync.BOTH:
        return 'both';

      default:
        return null;
    }
  }();

  return "appMarketplace.storefront.filters.sync.items." + key;
});
exports.getDataSyncFilterI18nKey = getDataSyncFilterI18nKey;
var getSupportSourceFilterI18nKey = (0, _memoize.default)(function (supportSource) {
  var key = function () {
    switch (supportSource) {
      case SupportSource.HUBSPOT:
        return 'hubspot';

      case SupportSource.APP_PARTNER:
        return 'appPartner';

      default:
        return null;
    }
  }();

  return "appMarketplace.storefront.filters.supportSource.items." + key;
});
exports.getSupportSourceFilterI18nKey = getSupportSourceFilterI18nKey;


//////////////////
// WEBPACK FOOTER
// ./js/utils/i18n.js
// module id = 99
// module chunks = 209 210 211 212